import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { money, formatDateAT } from "@/lib/format";

const KPIS = [
  { key: "restaurants", label: "Total restaurants" },
  { key: "active_restaurants", label: "Active" },
  { key: "users", label: "Total users" },
  { key: "signups_month", label: "Signups this month" },
  { key: "ai_captures_month", label: "AI captures (M)" },
  { key: "photo_scans_month", label: "Photo scans (M)" },
  { key: "daily_closes_month", label: "Daily closes (M)" },
];

const MONEY_KPIS = [
  { key: "platform_revenue_month", label: "Platform revenue (M)" },
  { key: "platform_expenses_month", label: "Platform expenses (M)" },
];

export default function AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { (async () => { const { data } = await api.get("/admin/overview"); setData(data); })(); }, []);
  if (!data) return <div className="text-sm text-muted-foreground">Loading…</div>;
  const t = data.totals || {};
  return (
    <div className="space-y-4" data-testid="admin-overview">
      <div>
        <h1 className="text-2xl font-bold font-display tracking-tight">Platform Overview</h1>
        <p className="text-sm text-muted-foreground font-mono">{data.current_month}</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {KPIS.map((k) => (
          <Card key={k.key} data-testid={`admin-kpi-${k.key}`}>
            <CardContent className="p-4">
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{k.label}</div>
              <div className="font-mono text-xl font-semibold mt-1">{t[k.key] ?? 0}</div>
            </CardContent>
          </Card>
        ))}
        {MONEY_KPIS.map((k) => (
          <Card key={k.key} data-testid={`admin-kpi-${k.key}`}>
            <CardContent className="p-4">
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{k.label}</div>
              <div className="font-mono text-xl font-semibold mt-1">{money(t[k.key] || 0)}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader className="pb-2"><CardTitle className="text-base">Latest tenants</CardTitle></CardHeader>
        <CardContent>
          <ul className="divide-y">
            {(data.latest_restaurants || []).map((r) => (
              <li key={r.id} className="py-2 flex items-center gap-3">
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold truncate">{r.brand_name || r.name}</div>
                  <div className="text-[11px] text-muted-foreground font-mono">{r.slug} · {formatDateAT(r.created_at)}</div>
                </div>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
